import React, { useRef, useState ,useEffect} from 'react'
import { Checkbox, Select } from 'antd';
import { CaretDownOutlined,CheckOutlined } from '@ant-design/icons'





const SelectCasteDropdownUtil = (props) => {
  const selectRef = useRef();
  const [searchText, setSearchText] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false); // State to control dropdown open/close

  const handleChange = (selectedValues) => {
    props?.onChange(selectedValues);
  };

  const handleCheckboxChange = (e, option) => {
    const { checked } = e.target;
    let newValue = [...(props.value || [])];

    if (checked) {
      if (!newValue.includes(option.id.toString())) {
        newValue.push(option.id.toString());
      }
    } else {
      newValue = newValue.filter((id) => id !== option.id.toString());
    }

    props?.onChange(newValue);

    // Close the dropdown after selecting a checkbox
    setDropdownOpen(false);
    setSearchText(""); // Also reset search text
  };

  const allCastes = props?.option?.castes || [];
  const suggestedCastes = props?.option?.suggestedcaste || [];
  const allCastesWithSuggested = [...suggestedCastes, ...allCastes];



  // Filter options based on search text
  const filteredOptions = allCastesWithSuggested.filter((option) =>
    option.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const isEmpty = filteredOptions.length === 0;

  // Filtered suggested castes
  const filteredSuggestedCastes = filteredOptions.filter((option) =>
    suggestedCastes.some((sc) => sc.id === option.id)
  );

  
  // Filtered all castes
  const filteredAllCastes = filteredOptions.filter((option) =>
    allCastes.some((ac) => ac.id === option.id)
  );


  return (
    <>
      {props?.value !== undefined && (
        <Select
          {...props}
          showSearch
          style={{
            width: "100%",
            overflowY: "hidden",
            border: "1px solid #CFCFCF",
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",
          }}
          className={
            props?.menu === "aferRegister"
              ? "new disabled"
              : props?.fieldType >= 67 && props?.fieldType <= 84
              ? "assets additional"
              : props?.styles
              ? "highlight"
              : "dropdownselect litescroll-bar"
          }
          showArrow={
            props?.menu === "aferRegister" ||
            (props?.fieldType >= 67 && props?.fieldType <= 84)
          }
          mode="multiple"
          autoComplete="none"
          id={props?.id}
          name={props?.name}
          value={props?.value}
          optionFilterProp="children"
          onSearch={(value) => setSearchText(value)} // Capture search input
          onChange={handleChange}
          filterOption={false} // Disable default filtering
          open={dropdownOpen} // Control dropdown open/close
          onDropdownVisibleChange={(open) => {
            setDropdownOpen(open);
            if (!open) {
              setSearchText(""); // Reset search text when dropdown closes
            }
          }}
          dropdownRender={(menu) => (
            <div style={{ position: "relative", maxHeight: "355px", overflowY: "auto" }}>
              {isEmpty ? (
                <div className="px-3 py-2 text-center text-gray-500">
                  No data found
                </div>
              ) : (
                <>
                  {/* Suggested Castes Section */}
                  {filteredSuggestedCastes.length > 0 && (
                    <div>
                      <div className="px-3 py-2 text-[#1E1E1E] font-bold bg-white border-b border-[#CFCFCF]">
                        <div className="text-[#1E1E1E] text-[16px] font-bold">
                          Suggested Caste
                        </div>
                      </div>
                      <div className="">
                        {filteredSuggestedCastes.map((option) => (
                          <div
                            key={option.id}
                            className="flex items-center px-2 py-1"
                          >
                            <Checkbox
                              checked={props?.value
                                ?.map(String)
                                .includes(option.id.toString())}
                              onChange={(e) => handleCheckboxChange(e, option)}
                            >
                              {option.name}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* All Castes Section */}
                  {filteredAllCastes.length > 0 && (
                    <div>
                      <div className="px-3 py-2 text-[#1E1E1E] font-bold bg-white border-b border-[#CFCFCF]">
                        <div className="text-[#1E1E1E] text-[16px] font-bold">
                          All Other Caste
                        </div>
                      </div>
                      <div className="">
                        {filteredAllCastes.map((option) => (
                          <div
                            key={option.id}
                            className="flex items-center px-2 py-1"
                          >
                            <Checkbox
                              checked={props?.value
                                ?.map(String)
                                .includes(option.id.toString())}
                              onChange={(e) => handleCheckboxChange(e, option)}
                            >
                              {option.name}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          options={filteredOptions.map((option) => ({
            value: option.id.toString(),
            label: option?.name,
          }))}
        />
      )}

      {props?.errors && (
        <p className="text-[red] text-[12px]">{props?.errors}</p>
      )}
    </>
  );
};

const SelectSubCasteDropdownUtil = (props) => {
  const selectRef = useRef();
  const [searchText, setSearchText] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleChange = (selectedValues) => {
    props?.onChange(selectedValues);
  };

  const handleCheckboxChange = (e, option) => {
    const { checked } = e.target;
    let newValue = [...(props.value || [])];

    const valueAsString = option.id.toString();
    if (checked) {
      if (!newValue.includes(valueAsString)) {
        newValue.push(valueAsString);
      }
    } else {
      newValue = newValue.filter((id) => id !== valueAsString);
    }

    props?.onChange(newValue);

    // Close the dropdown and reset search text
    setDropdownOpen(false);
    setSearchText(""); // Reset search text to show all options
  };

  const allSubCastes = props?.option?.subcastes || [];
  const suggestedSubCastes = props?.option?.suggestedsubcaste || [];
  const combinedSubCastes = [...suggestedSubCastes, ...allSubCastes];

  // ✅ Filter logic
  const filteredOptions = combinedSubCastes.filter((option) =>
    option.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const filteredSuggested = filteredOptions.filter((opt) =>
    suggestedSubCastes.some((ssc) => ssc.id === opt.id)
  );
  const filteredAll = filteredOptions.filter((opt) =>
    allSubCastes.some((asc) => asc.id === opt.id)
  );

  const isEmpty = filteredOptions.length === 0;

  return (
    <>
      {props?.value !== undefined && (
        <Select
          {...props}
          ref={selectRef}
          mode="multiple"
          showSearch
          value={props?.value}
          style={{
            width: "100%",
            border: "1px solid #CFCFCF",
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",
          }}
          className={
            props?.menu === "aferRegister"
              ? "new disabled"
              : props?.fieldType >= 67 && props?.fieldType <= 84
              ? "assets additional"
              : props?.styles
              ? "highlight"
              : "dropdownselect litescroll-bar"
          }
          autoComplete="none"
          optionFilterProp="children"
          onSearch={(val) => setSearchText(val)} // Capture search input
          onChange={handleChange}
          filterOption={false}
          open={dropdownOpen}
          onDropdownVisibleChange={(open) => {
            setDropdownOpen(open);
            if (!open) {
              setSearchText(""); // Reset search text when dropdown closes
            }
          }}
          dropdownRender={() => (
            <div style={{ position: "relative", maxHeight: "355px", overflowY: "auto" }}>
              {isEmpty ? (
                <div className="px-3 py-2 text-center text-gray-500">
                  No data found
                </div>
              ) : (
                <>
                  {/* Suggested SubCastes */}
                  {filteredSuggested.length > 0 && (
                    <div>
                      <div className="px-3 py-2 text-[#1E1E1E] font-bold bg-white border-b border-[#CFCFCF]">
                        <div className="text-[#1E1E1E] text-[16px] font-bold">
                          Suggested Sub Caste
                        </div>
                      </div>
                      <div className="">
                        {filteredSuggested.map((option) => (
                          <div key={option.id} className="flex items-center px-2 py-1">
                            <Checkbox
                              checked={props.value.includes(option.id.toString())}
                              onChange={(e) => handleCheckboxChange(e, option)}
                            >
                              {option.name}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* All Other SubCastes */}
                  {filteredAll.length > 0 && (
                    <div>
                      <div className="px-3 py-2 text-[#1E1E1E] font-bold bg-white border-b border-[#CFCFCF]">
                        <div className="text-[#1E1E1E] text-[16px] font-bold">
                          All Other Sub Caste
                        </div>
                      </div>
                      <div className="">
                        {filteredAll.map((option) => (
                          <div key={option.id} className="flex items-center px-2 py-1">
                            <Checkbox
                              checked={props.value.includes(option.id.toString())}
                              onChange={(e) => handleCheckboxChange(e, option)}
                            >
                              {option.name}
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          // We must still provide 'options' prop to satisfy Select's internal logic
          options={filteredOptions.map((option) => ({
            value: option.id.toString(),
            label: option.name,
          }))}
        />
      )}
      {props?.errors && (
        <p className="text-[red] text-[12px]">{props.errors}</p>
      )}
    </>
  );
};




const SelectDropdownUtil = (props) => {
  const selectRef = useRef();


  return (
    props?.value !== undefined && (
      <>
        <Select
          {...props}
          showSearch
          style={{
            width: "100%",
          }}
          className={
            props?.menu === "aferRegister"
              ? "new disabled"
              : props?.fieldType >= 67 && props?.fieldType <= 84
              ? "assets additional"
              : props?.styles
              ? "highlight"
              : ""
          }
          mode="multiple"
          autoComplete="none"
          id={props?.id}
          name={props?.name}
          defaultValue={props.defalutValue ? props?.defalutValue : props?.placeholder}
          optionFilterProp="children"
          showArrow={
            props?.menu === "aferRegister" || (props?.fieldType >= 67 && props?.fieldType <= 84)
          }
          ref={selectRef}
          disabled={props?.isDisabled}
          onChange={(event) => {
            props?.onChange(event);
            if (props.isFromProfile === "MyProfile" || props.isFromAdditional === true) {
              return "";
            } else {
              setTimeout(() => {
                selectRef.current.blur();
              }, 0);
            }
          }}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={
            Array.isArray(props.option)
              ? props.isFromProfile === "MyProfile" || props.isFromAdditional === true
                ? props.option.map((option, i) => ({
                    value: option.id.toString(),
                    label: (
                      <div className="flex justify-between items-center">
                        {props.name === "countryNameId" ? option.country : option.name}
                        {!props.value?.includes(option.id.toString()) && (
                          <CheckOutlined style={{ color: "grey" }} />
                        )}
                      </div>
                    ),
                  }))
                : props.option.map((option, i) =>
                    option.heading === "Y"
                      ? {
                          label: option.name,
                          options: [
                            {
                              label: option.name,
                              value: option.id,
                            },
                          ],
                        }
                      : {
                          value:
                            props.name === "countryNameId" ||
                            props.name === "currencyId" ||
                            props.name === "countryId" ||
                            props.name === "pMobileNumberCode"
                              ? option.id.toString()
                              : props.name === "maritalStatus"
                              ? option.name
                              : props.name === "maritalStatusId"
                              ? option.id
                              : option.id,
                          label:
                            props.name === "countryNameId"
                              ? option.country
                              : props.name === "currencyId"
                              ? option.currency + "," + option.country
                              : props.name === "countryId" || props.name === "pMobileNumberCode"
                              ? option.isdcode + "," + option.country
                              : option.name,
                        }
                  )
              : [] // Fallback to an empty array if props.option is not an array
          }
        />

        {props?.errors && <p className="text-[red] text-[12px]">{props?.errors}</p>}
      </>
    )
  );
};



const SelectDropdownUtilHeading = (props) => {
return (
  props?.value != undefined &&
  <>
  <Select
  // suffixIcon={<CaretDownOutlined />}
  {...props}
  showSearch
  style={{
    width: "100%"
  }}
  className={props?.menu=="aferRegister" ?"new ":""}
  mode="multiple"
  autoComplete="none"
  id={props?.id}
  name={props?.name}
  defaultValue={props.defalutValue?props?.defalutValue:props?.placeholder} 
  optionFilterProp="children"
  showArrow={props?.menu=="aferRegister"}
  onChange={event => {
      props?.onChange(event)}}
  filterOption={(input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  }
  options={props?.option?.map((option,i)=>(
    option.heading == "Y" ?
  {
    label: option.name,
    options: 
    [
      {
        label: option.name,
        value: option.id,
      }
    ],
  }
  :
          {
              value: props?.name == "countryNameId" || props?.name == "currencyId" || props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.id.toString()
                     :option.id,
              label: props?.name == "countryNameId" ? 
                      option?.country:
                      props?.name == "currencyId"  ?
                      option.currency+","+option.country:
                      props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.isdcode+","+option.country:option.name,
            }
  ))
    
  }
/>

{props?.errors && (
  <p className="text-[red] text-[12px]">
    {props?.errors}
  </p>
)}{" "}
</>
)
}




const LocationSingleSelectDropdown = (props) => {
return (
  props?.value != undefined &&
  <>
  <div className='hidden md:block'>
  <Select
  // suffixIcon={<CaretDownOutlined />}
  {...props}
  showSearch
  style={{
    width: "100%"
  }}
  placeholder={props?.placeholder}
  className= {props?.menu=="afterReigister" ?"new text-[#7A7A7A] font-bold text-[14px]" :'text-[#7A7A7A] font-bold text-[14px]'}
  // onSearch={(e)=>{if(e.length>2){ props.callBackSearch(e)}}}
  onSearch={(e) => {
    if (e.length > 2) {
      props.callBackSearch(e); // Ensure this correctly updates the dropdown options
    }
  }}
  id={props?.id}
  name={props?.name}
  value={props?.value}
  defalutValue={props.defalutValue?props?.defalutValue:props?.placeholder}
  optionFilterProp="children"
  onChange={event => {
      props?.onChange(event)}}

  filterOption={(input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  }
  options={props?.option?.map((option,i)=>(
          {
              value: props?.name == "countryNameId" || props?.name == "currencyId" || props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.id.toString()
                     :props.name==="placeOfBirth"?option.cityId :option.id,
              label: props?.name == "countryNameId" ? 
                      option?.country:
                      props?.name == "currencyId"  ?
                      option.currency+","+option.country:
                      props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.isdcode+","+option.country: props.name==="placeOfBirth"?
                     `${option?.placeName}-${option?.regionName}-${option?.countryName}`
                     :option.name,
            }
  ))
  }
  disabled={props.disabled}
/>

{props?.errors && (
  <p className="text-[red] text-[12px]">
    {props?.errors}
  </p>
)}{" "}
</div>

<>
    <div className={`flex md:hidden gap-3 items-center  mb-[2rem] `}>
                <img alt='' className="w-[2.5rem] h-[2.5rem]" src={props?.icon} />
                <div className={`relative w-full md:hidden`}>
                    <p className={` absolute -top-3 left-3 bg-white px-1 text-[12px] text-[#8F8F8F] md:text-[12px] lg:text-[14px] md:text-[#7A7A7A] flex  transition-all duration-200 
            peer-placeholder-shown:top-2.5 peer-placeholder-shown:left-4 peer-placeholder-shown:bg-transparent 
          peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-base 
            peer-focus:-top-3 peer-focus:left-3 peer-focus:bg-white peer-focus:text-[#8F8F8F]`}>
                        {props?.title}
                        {props?.required && <span className="text-[#D10A11] ml-1"> *</span>}
                    </p>
                    <label className={` pepeer block border-[1px] !w-[100%] border-[#8F8F8F] rounded-[3px] bg-transparent md:px-4 text-gray-900 `}>
                      
  <Select
  // suffixIcon={<CaretDownOutlined />}
  {...props}
  showSearch
  style={{
    width: "100%"
  }}
  placeholder={props?.placeholder}
  className= {props?.menu=="afterReigister" ?"new text-[#7A7A7A] font-bold text-[14px]" :'text-[#7A7A7A] font-bold text-[14px] !w-[100%]'}
  // onSearch={(e)=>{if(e.length>2){ props.callBackSearch(e)}}}
  onSearch={(e) => {
    if (e.length > 2) {
      props.callBackSearch(e); // Ensure this correctly updates the dropdown options
    }
  }}
  id={props?.id}
  name={props?.name}
  value={props?.value}
  defalutValue={props.defalutValue?props?.defalutValue:props?.placeholder}
  optionFilterProp="children"
  onChange={event => {
      props?.onChange(event)}}

  filterOption={(input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  }
  options={props?.option?.map((option,i)=>(
          {
              value: props?.name == "countryNameId" || props?.name == "currencyId" || props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.id.toString()
                     :props.name==="placeOfBirth"?option.cityId :option.id,
              label: props?.name == "countryNameId" ? 
                      option?.country:
                      props?.name == "currencyId"  ?
                      option.currency+","+option.country:
                      props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.isdcode+","+option.country: props.name==="placeOfBirth"?
                     `${option?.placeName}-${option?.regionName}-${option?.countryName}`
                     :option.name,
            }
  ))
  }
  disabled={props.disabled}
/>
</label>

{props?.errors && (
  <p className="text-[red] text-[12px]">
    {props?.errors}
  </p>
)}{" "}

</div>
</div>
</>
</>
)
}

const SingleSelectDropdown = (props) => {
return (
  props?.value != undefined &&
  <>
  <Select
  // suffixIcon={<CaretDownOutlined />}
  {...props}
  showSearch
  style={{
    width: "100%"
  }}
  placeholder={props?.placeholder}
  className= {props?.menu=="afterReigister" ?"new text-[#7A7A7A] font-bold text-[14px]" :'text-[#7A7A7A] font-bold text-[14px]'}
  // onSearch={(e)=>{if(e.length>2){ props.callBackSearch(e)}}}
  onSearch={(e) => {
    if (e.length > 2) {
      props.callBackSearch(e); // Ensure this correctly updates the dropdown options
    }
  }}
  id={props?.id}
  name={props?.name}
  value={props?.value}
  defalutValue={props.defalutValue?props?.defalutValue:props?.placeholder}
  optionFilterProp="children"
  onChange={event => {
      props?.onChange(event)}}

  filterOption={(input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  }
  options={props?.option?.map((option,i)=>(
          {
              value: props?.name == "countryNameId" || props?.name == "currencyId" || props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.id.toString()
                     :props.name==="placeOfBirth"?option.cityId :option.id,
              label: props?.name == "countryNameId" ? 
                      option?.country:
                      props?.name == "currencyId"  ?
                      option.currency+","+option.country:
                      props?.name == "countryId" || props.name == "pMobileNumberCode" ?
                     option?.isdcode+","+option.country: props.name==="placeOfBirth"?
                     `${option?.placeName}-${option?.regionName}-${option?.countryName}`
                     :option.name,
            }
  ))
  }
  disabled={props.disabled}
/>

{props?.errors && (
  <p className="text-[red] text-[12px]">
    {props?.errors}
  </p>
)}{" "}
</>
)
}



const PincodeSingleSelectDropdown = (props) => {
return (
  props?.value != undefined &&
  <>
   <Select
    filterOption={false}
    showSearch={true}
    onChange={props?.onSelect}
    onSearch={props?.onSearch}
    id={props?.id.toString()}
    name={props?.name}
    // onChange={event =>{
    //   if(props?.onSelect){
    //     props?.onSelect(event)
    //   }
    //   return props?.onChange(props?.name)(event.toString())}
    // } 
    placeholder={props?.placeholder}
    defaultValue={props.value}
    value={props.value}
    
    options={props?.options}
      notFoundContent="No matches"
      style={{
        width: "100%"
      }}
  />

{props?.errors && (
  <p className="text-[red] text-[12px]">
    {props?.errors}
  </p>
)}{" "}
</>
)
}

export {SelectDropdownUtil,SelectDropdownUtilHeading, SingleSelectDropdown ,PincodeSingleSelectDropdown ,LocationSingleSelectDropdown ,SelectCasteDropdownUtil ,SelectSubCasteDropdownUtil}